import React from 'react';
import { Link } from 'react-router-dom';

export const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow rounded-lg p-8">
          <div className="mb-8">
            <Link to="/" className="text-blue-600 hover:text-blue-500">
              ← Back to Home
            </Link>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="prose max-w-none">
            <p className="mb-4">Last updated: January 9, 2025</p>

            <h2 className="text-xl font-semibold mt-6 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using SayCard, you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use our service.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-4">2. Description of Service</h2>
            <p>
              SayCard provides a voice-to-contact service that converts spoken words into digital contact information. The service includes voice recognition, contact creation, and contact sharing features.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-4">3. Disclaimer of Warranties</h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND. WE DO NOT GUARANTEE THE ACCURACY OF VOICE RECOGNITION OR CONTACT INFORMATION PROCESSING.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-4">4. Limitation of Liability</h2>
            <p>
              IN NO EVENT SHALL SAYCARD BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-4">5. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Provide accurate information</li>
              <li>Maintain the security of your account</li>
              <li>Not misuse or abuse the service</li>
              <li>Comply with all applicable laws</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-4">6. Data Usage</h2>
            <p>
              By using our service, you grant us the right to process your voice recordings for the purpose of creating contact information. We do not store voice recordings after processing.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-4">7. Modifications to Service</h2>
            <p>
              We reserve the right to modify or discontinue the service at any time, with or without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuance.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-4">8. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of the jurisdiction in which SayCard operates, without regard to its conflict of law provisions.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-4">9. Contact</h2>
            <p>
              For any questions about these Terms of Service, please contact us at terms@saycard.app
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
